export default {
  root: {
    background: '#f4f7fa',
    boxShadow: '0px 1px 8px rgba(0,0,0,0.2)'
  },
  body: {
    flex: 1,
    padding: [0, 18, 20],
    overflow: 'auto'
  },
  drawerWrap: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  toggle: {}
};
